import { SharedModule } from './../shared/shared.module'
import { PipesModule } from './../../pipes/pipes.module'
import { FormsModule } from '@angular/forms'
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { GeneralProgrammingComponent } from './general-programming.component'
import { SubEventComponent } from './sub-event/sub-event.component'
import { ModalTemplateComponent } from './modal-template/modal-template.component'


@NgModule({
  declarations: [GeneralProgrammingComponent, SubEventComponent, ModalTemplateComponent],
  imports: [
    CommonModule,
    NgbNavModule,
    PipesModule,
    FormsModule,
    SharedModule
  ],
  exports: [GeneralProgrammingComponent]
})
export class GeneralProgrammingModule { }
